<script lang="ts">
    import Vue from "vue";

    export default Vue.component("ValidationError", {
        props: {
            context: String,
            errors: Array
        },
        computed: {
            error: function () {
                const error = this.errors?.find(_ => _.Context == this.context);
                return error;
            }
        }
    });
</script>

<template>
    <div class="error">{{error ? error.Error : ''}}</div>
</template>
